import { formatMoney } from '../../check-batch/format';
import type { ContractorBatchTotals } from '../types';

/** The blue totals bar. Gross = net = check amount for a contractor (no withholding), so there is one payment total and one check total. */
export function ContractorSummaryBar({ totals }: { totals: ContractorBatchTotals }) {
  return (
    <dl className="wc-summary" data-testid="summary-bar">
      <div><dt>Contractors Selected</dt><dd data-testid="summary-contractors">{totals.contractorsIncluded}</dd></div>
      <div><dt>Payment Total</dt><dd data-testid="summary-payment">{formatMoney(totals.paymentTotal)}</dd></div>
      <div><dt>Check Total</dt><dd data-testid="summary-check">{formatMoney(totals.checkTotal)}</dd></div>
    </dl>
  );
}
